import React, { useState, useEffect } from "react";

const ProgressBar = ({ chunkSize, lieCount, truthCount }) => {
  const [filledLie, setFilledLie] = useState(0);
  const [filledTruth, setFilledTruth] = useState(0);
  const [verticalMark, setVerticalMark] = useState({
    half: false,
    full: false
  });

  useEffect(() => {
    if (lieCount !== 0 && chunkSize !== 0 && filledTruth < 100) {
      if (
        filledLie <
          lieCount * Math.ceil(chunkSize) + truthCount * Math.ceil(chunkSize) &&
        filledLie < 100
      ) {
        setFilledLie((prev) => (prev += 1));
      } else if (
        filledLie >
        lieCount * Math.ceil(chunkSize) + truthCount * Math.ceil(chunkSize)
      ) {
        setFilledLie((prev) => (prev -= 1));
      }
    } else if (lieCount === 0) {
      setFilledLie(0);
    }
  }, [filledLie, filledTruth, lieCount, chunkSize]);

  useEffect(() => {
    if (truthCount !== 0 && chunkSize !== 0 && filledTruth < 100) {
      if (
        filledTruth < truthCount * Math.ceil(chunkSize) &&
        filledTruth < 100
      ) {
        setFilledTruth((prev) => (prev += 1));
      } else if (filledTruth > truthCount * Math.ceil(chunkSize)) {
        setFilledTruth((prev) => (prev -= 1));
      }
    } else if (truthCount === 0) {
      setFilledTruth(0);
    }
  }, [filledTruth, truthCount, chunkSize]);

  useEffect(() => {
    if (filledTruth === 100) {
      setTimeout(() => {
        setVerticalMark({ ...verticalMark, half: true });
      }, 250);
      setTimeout(() => {
        setVerticalMark({ ...verticalMark, half: true, full: true });
      }, 500);
    } else if (filledTruth > 49) {
      setTimeout(() => {
        setVerticalMark({ ...verticalMark, half: true });
      }, 500);
    }
  }, [filledLie, filledTruth]);

  const progressStyles = {
    height: "100%",
    position: "absolute",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    transition: "width 0.5s linear"
  };

  return (
    <div className="ttl-score-meter">
      <div className="progress-bar-container">
        <div
          style={{
            ...progressStyles,
            width: `${filledLie}%`,
            background: "#D25381"
          }}
        >
          {lieCount ? <h2 className="guessed-lie-text">{lieCount}</h2> : <></>}
        </div>
        <div
          style={{
            ...progressStyles,
            width: `${filledTruth}%`,
            background: "#23D550",
            zIndex: 1
          }}
        >
          {truthCount ? (
            <h2 className="guessed-lie-text">{truthCount}</h2>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className="liar-points">
        <div className="liar-point-mark">
          <h2 className="liar-mark-text">+200</h2>
          <div
            className={`liar-vertical-mark ${
              verticalMark.half ? "mark-color-green" : "mark-color-gray"
            }`}
          ></div>
        </div>
        <div className="liar-point-mark">
          <h2 className="liar-mark-text">+300</h2>
          <div
            className={`liar-vertical-mark ${
              verticalMark.full ? "mark-color-green" : "mark-color-gray"
            }`}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
